<template>
    <div class="installation">
        <h1>Installation</h1>
        <div>
            You have successfully installed Storyblok Commerce.<br />
            To get started please read the setup guide.
            <div class="installation__button">
                <a
                    target="_blank"
                    class="el-button el-button--primary"
                    href="https://www.storyblok.com/commerce/docs/setup"
                    >Open setup guide</a
                >
            </div>
            <h2>Public API-Key</h2>
            Use this key to get the catalogue data and to manage the cart.
            <div class="apikey" v-if="public">
                <el-input v-model="public.key" readonly></el-input>
            </div>
            <h2>Private API-Key</h2>
            Use this key to get full access to orders and the catalogue. <br />
            DON'T share the private token in public!
            <div class="apikey" v-if="private">
                <el-input v-model="private.key" readonly></el-input>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['rootConfig'],

    data() {
        return {
            api_keys: [],
        };
    },

    computed: {
        public() {
            return this.api_keys.filter((key) => {
                return key.access === 'public';
            })[0];
        },
        private() {
            return this.api_keys.filter((key) => {
                return key.access === 'private';
            })[0];
        },
    },

    created() {
        let api = this.$resource(
            this.rootConfig.endPoint + '/api_keys/{id}',
            {},
            {},
            { headers: this.rootConfig.headers }
        );
        api.get().then((res) => {
            this.api_keys = res.body;
        });
    },
};
</script>

<style scoped>
.installation {
    text-align: center;
    max-width: 500px;
    margin: 0 auto;
}

.installation__button {
    margin-top: 20px;
}

.apikey {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// Install.vue?b79a1b26